export default {
    'header': {
        'barbara_minto': 'Barbara Minto',
        'concept': 'Pyramid Concept',
        'contact': 'Contact',
        'corporate_inquiry': 'Corporate Inquiry',
        'liveMintoCourse': 'Live Minto Course',
        'policies': 'Policies',
        'summary': 'Barbara in your pocket',
        'press': 'Press',
        'T&Cs': 'T&Cs',
        'textbook': 'Textbook',
        'workbook': 'Original Workbook Course',
        'login': 'Log In',
        'buy': 'Buy the course',
        'testimonials': 'Testimonials',
        'online': 'Online Course',
        'error404': 'Error 404',
        'dashboard': '',
        'thankYou': 'Thank You',
        'paymentFailure': 'Payment Failure',
    }
}



// WEBPACK FOOTER //
// ./client/app/components/header/i18n/es.js